import type { UI5Version, ExtensionLogger, ExportResults } from '../..';
import type { v2, PageTypeV2 } from '@sap/ux-specification-types';
import type { FlexChangesForTransfer } from './import/controls/table';
import type { MetadataFactory, MetadataInstanceInterface } from '../common/decoration/factory';
import type * as v2controls from './export/controls';
import type * as v2pages from './export/pages';
import type { Definition } from 'typescript-json-schema';
import type { IdGeneratorFunction } from '@sap-ux/fe-fpm-writer';
export type V2Controls = typeof v2controls;
export type V2Pages = typeof v2pages;

export type TransferParameterTypeV2 = {
    v2Page: v2.SapUiAppPageV2;
    exportResults: ExportResults;
    appId: string;
    baseId: string;
    appSchema: object;
    ui5Version: UI5Version;
    factory: MetadataFactory;
    pageKeys: string[];
    pageType: PageTypeV2;
    logger: ExtensionLogger;
    propertyDefinition?: object;
    nextDefinition?: object;
    entityPathArray?: string[];
    deletionRequest: boolean;
    idGeneratorFunction: IdGeneratorFunction;
};

export const MULTISELECTTABLE = 'ResponsiveTableWithMultiSelect<LineItems>';
export const INLINEDELETETABLE = 'ResponsiveTableWithInlineDelete<LineItems>';
export const TREETABLE = 'TreeTable<LineItems>';
export const ANALYTICALTABLE = 'AnalyticalTable<LineItems>';
export const GRIDTABLE = 'GridTable<LineItems>';
export const LINEITEMTABLETYPES = [MULTISELECTTABLE, INLINEDELETETABLE, TREETABLE, ANALYTICALTABLE, GRIDTABLE];
export const ALPTABLETYPES = [
    'ALPResponsiveTable<LineItems>',
    'ALPGridTable<LineItems>',
    'ALPAnalyticalTable<LineItems>'
];

export const OP_STANDARD_HEADER_ACTION_PREFIX = 'template::';
export const OP_STANDARD_FOOTER_ACTION_PREFIX = 'template:::ObjectPageAction:::';

export enum SectionTypeV2 {
    SectionAddress = 'ObjectPageSectionAddressV2',
    SectionChart = 'ObjectPageSectionChartV2',
    SectionContact = 'ObjectPageSectionContactV2',
    SectionForm = 'ObjectPageSectionFormV2',
    Section = 'ObjectPageSectionV2',
    SubSection = 'ObjectPageSubSectionV2',
    SectionTable = 'ObjectPageSectionTableV2',
    SubSectionForm = 'ObjectPageSubSectionFormV2',
    SubSectionTable = 'ObjectPageSubSectionTableV2',
    SubSectionAddress = 'ObjectPageSubSectionAddressV2',
    SubSectionContact = 'ObjectPageSubSectionContactV2',
    SubSectionChart = 'ObjectPageSubSectionChartV2',
    CommonHeaderFacetSettings = 'CommonHeaderFacetSettings',
    HeaderSection = 'ObjectPageHeaderSection',
    HeaderSectionAddress = 'ObjectPageHeaderSectionAddress',
    HeaderSectionChart = 'ObjectPageHeaderSectionChart',
    HeaderSectionCustomFragment = 'ObjectPageCustomHeaderSectionFragment',
    HeaderSectionDataPoint = 'ObjectPageHeaderSectionDataPoint',
    HeaderSectionForm = 'ObjectPageHeaderSectionForm'
}

export enum ActionTypeV2 {
    Form = 'FormAction',
    OPHeader = 'ObjectPageHeaderAction',
    OPToolBar = 'ObjectPageToolBarAction',
    OPFooter = 'ObjectPageFooterAction',
    OPColumn = 'ObjectPageTableColumnAction',
    ToolBar = 'ToolBarAction',
    Footer = 'FooterAction',
    Column = 'TableColumnAction',
    ToolBarIntentBased = 'ToolBarActionIntentBased',
    FooterIntentBased = 'FooterActionIntentBased',
    ColumnIntentBased = 'TableColumnActionIntentBased',
    HeaderStandard = 'HeaderActionStandard',
    OPHeaderStandard = 'ObjectPageHeaderActionStandard',
    OPFooterStandard = 'ObjectPageFooterActionStandard'
}

export type ObjectPageV2ConfigParameters = {
    factory: MetadataInstanceInterface;
    pageKeys: string[];
    flexChanges: FlexChangesForTransfer;
    v2Page: v2.SapUiAppPageV2;
    objectPageConfig?: v2.ObjectPageConfigV2;
};

export type SectionPartProperties = {
    id?: string;
    type?: SectionTypeV2;
    schema?: Definition;
    title?: string;
};
